import { render } from "./VedExportButtons.vue?vue&type=template&id=dfbe7782&ts=true"
import script from "./VedExportButtons.vue?vue&type=script&lang=ts"
export * from "./VedExportButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__